import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import App from "./App";
import {CURRENT_CUSTOMER_KEY} from "./layouts/SelfcareLayout";
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from "react-router-dom";
import ErrorMessage from "./components/selfcare/ErrorMessage.tsx";

// eslint-disable-next-line react-refresh/only-export-components
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string
// eslint-disable-next-line react-refresh/only-export-components
const RELEASE = window.release
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string
const REPORT_TO_SENTRY = import.meta.env.VITE_REPORT_TO_SENTRY as string

if(REPORT_TO_SENTRY === 'true') {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: ENVIRONMENT,
        release: RELEASE,
        denyUrls: [
            /^https:\/\/static\.zdassets\.com\/ekr\/snippet\.js.*/i,
            /^chrome-extension:\/\/.*/i,
            /^moz-extension:\/\/.*/i,
            /^safari-web-extension:\/\/.*/i,
        ],
        ignoreErrors: [
            'NetworkError: A network error occurred.',
            'message: Hotjar not launching due to suspicious userAgent'
        ],
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
            Sentry.captureConsoleIntegration({'levels': ['warn', 'error', 'assert']}),
            Sentry.httpClientIntegration(),
            // Sentry.thirdPartyErrorFilterIntegration({
                // Specify the application keys that you specified in the Sentry bundler plugin
                // filterKeys: ["hiper-68ced854-3aa9-49ea-807c-da928c878c82"],

                // Defines how to handle errors that contain third party stack frames.
                // Possible values are:
                // - 'drop-error-if-contains-third-party-frames'
                // - 'drop-error-if-exclusively-contains-third-party-frames'
                // - 'apply-tag-if-contains-third-party-frames'
                // - 'apply-tag-if-exclusively-contains-third-party-frames'
                // behaviour: "drop-error-if-exclusively-contains-third-party-frames",
            // }),
        ],
        tracesSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.00,
        replaysSessionSampleRate: 0,
    });

    const customer_id = localStorage.getItem(CURRENT_CUSTOMER_KEY)

    if (customer_id) {
        Sentry.setUser({id: customer_id, segment: "customer"});
    } else {
        if (Cookies.get('SENTRY-UUID') === undefined) {
            Cookies.set('SENTRY-UUID', uuidv4(), {secure: true, sameSite: 'strict'});
        }
        Sentry.setUser({id: Cookies.get('SENTRY-UUID'), segment: "guest"});
    }


    window.addEventListener('unhandledrejection',(event: PromiseRejectionEvent) => {
        Sentry.captureException(event.reason, {
            extra: { unhandledPromise: true }
        })
    });
}

if (document.getElementById('react-root')) {
    ReactDOM.createRoot(document.getElementById('react-root') as HTMLElement).render(
        <Sentry.ErrorBoundary fallback={<ErrorMessage/>}>
            <App/>
        </Sentry.ErrorBoundary>
    );
}
